import { avdInventoryDescriptor } from "../avd/avdInventoryDescriptor";

import type { BundleInventoryDescriptor } from "./bundleDescriptors";

/** Every bundle type with a descriptor. A new type adds one entry here; the page does not change. */
export const BUNDLE_INVENTORY_DESCRIPTORS: readonly BundleInventoryDescriptor[] = [
	avdInventoryDescriptor,
];
